import { useState } from "react";
import { PagePanel, PageShell } from "../components/ui/page/PageShell";

const CGU = () => {
  const [activeSection, setActiveSection] = useState("article-1");

  const sections = [
    {
      id: "article-1",
      title: "Objet des conditions générales",
      article: "Article 1",
    },
    { id: "article-2", title: "Mentions légales", article: "Article 2" },
    { id: "article-3", title: "Définitions", article: "Article 3" },
    { id: "article-4", title: "Siège social", article: "Article 4" },
    { id: "article-5", title: "Objet du site", article: "Article 5" },
    { id: "article-6", title: "Accès au site", article: "Article 6" },
    {
      id: "article-7",
      title: "Conservation des données",
      article: "Article 7",
    },
    { id: "article-8", title: "Protection des données", article: "Article 8" },
    { id: "article-9", title: "Confidentialité", article: "Article 9" },
    {
      id: "article-10",
      title: "Téléchargement des données",
      article: "Article 10",
    },
    {
      id: "article-11",
      title: "Accessibilité et disponibilité",
      article: "Article 11",
    },
    {
      id: "article-12",
      title: "Engagement concernant l'utilisation du site et de son contenu",
      article: "Article 12",
    },
    { id: "article-13", title: "Sécurité du site", article: "Article 13" },
    {
      id: "article-14",
      title: "Propriété intellectuelle",
      article: "Article 14",
    },
    { id: "article-15", title: "Droits d'auteur", article: "Article 15" },
    { id: "article-16", title: "Marques", article: "Article 16" },
    {
      id: "article-17",
      title: "Responsabilité et force majeure",
      article: "Article 17",
    },
    { id: "article-18", title: "Cookies", article: "Article 18" },
    { id: "article-19", title: "Évolution des CGU", article: "Article 19" },
    { id: "article-20", title: "Durée", article: "Article 20" },
    { id: "article-21", title: "Droit applicable", article: "Article 21" },
  ];

  const scrollToSection = (sectionId: string) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <PageShell>
      <PagePanel className="lg:flex-row">
        {/* Table des matières */}
        <nav
          aria-label="Table des matières"
          className="shrink-0 border-b border-slate-200 bg-slate-50/60 p-3 lg:w-72 lg:overflow-y-auto lg:border-b-0 lg:border-r lg:p-4 xl:w-80"
        >
          <h2 className="mb-2 px-1 text-[11px] font-bold tracking-wider text-slate-400 uppercase">
            Table des matières
          </h2>
          <div className="flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] lg:flex-col lg:gap-1 lg:overflow-visible lg:pb-0 [&::-webkit-scrollbar]:hidden">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`shrink-0 cursor-pointer rounded-xl px-3 py-2 text-left font-Nunito transition-colors lg:shrink lg:w-full ${
                  activeSection === section.id
                    ? "bg-indigo-50 text-indigo-700 ring-1 ring-indigo-100 ring-inset"
                    : "text-slate-600 hover:bg-white hover:text-slate-900"
                }`}
              >
                <span className="block text-xs font-bold whitespace-nowrap lg:whitespace-normal">
                  {section.article}
                </span>
                <span className="mt-0.5 hidden text-xs opacity-70 lg:block">
                  {section.title}
                </span>
              </button>
            ))}
          </div>
        </nav>

        {/* Contenu principal */}
        <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="mx-auto max-w-3xl">
            <div className="mb-6">
              <p className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
                Mentions légales
              </p>
              <h1 className="mt-1.5 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
                Conditions Générales d'Utilisation
              </h1>
              <p className="mt-1.5 font-Nunito text-sm text-slate-500">
                DCA MONACO SAM — Plateforme DCA ERP
              </p>
            </div>

              {/* Article 1 */}
              <section
                id="article-1"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 1. Objet des conditions générales d'utilisation
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Les conditions générales d’utilisation ont pour objet de
                    préciser les modalités d’utilisation et de navigation au
                    sein du site et de la plateforme sécurisée, dénommés
                    respectivement « DCA ERP »
                  </p>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    Les présentes conditions générales d'utilisation
                    s'appliquent à tout utilisateur accédant à DCA ERP.
                  </p>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    Chaque utilisateur doit accepter, sans réserve, les
                    conditions générales d'utilisation lorsqu'il accède pour la
                    première fois à DCA ERP.
                  </p>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    Autrement dit, l’accès au site par l’utilisateur signifie
                    acceptation expresse et entière des conditions générales
                    d’utilisation.
                  </p>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    Par cette acceptation, l'utilisateur confirme avoir lu et
                    compris l'intégralité des conditions générales d'utilisation
                    avant toute utilisation des services proposés par DCA ERP et
                    s'engage à les respecter.
                  </p>
                </div>
              </section>

              {/* Article 2 */}
              <section
                id="article-2"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 2. Mentions légales
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    L'édition du Site est assurée par le service informatique de
                    DCA MONACO SAM.
                  </p>
                </div>
              </section>

              {/* Article 3 */}
              <section
                id="article-3"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 3. Définitions
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Les mots et expressions ci-après commençant par une lettre
                    majuscule, au singulier ou au pluriel, sont employés dans
                    les conditions générales d'utilisation avec la signification
                    suivante :
                  </p>
                  <div className="space-y-4">
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « Service IT »
                      </h4>
                      <p className="text-gray-700">
                        le département IT en charge de la gestion de la
                        plateforme DCA ERP chez DCA MONACO SAM.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « Compte professionnel »
                      </h4>
                      <p className="text-gray-700">
                        compte créé par l'utilisateur pour accéder à DCA ERP.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « Donnée(s) à caractère personnel »
                      </h4>
                      <p className="text-gray-700">
                        Toute information se rapportant à une personne physique
                        identifiée ou identifiable.Est réputée être une «
                        personne physique identifiable » toute personne physique
                        qui peut être identifiée, directement ou indirectement,
                        notamment par référence à un identifiant, tel qu’un nom,
                        un numéro d’identification, des données de localisation,
                        un identifiant en ligne, ou à un ou plusieurs éléments
                        spécifiques propres à son identité physique,
                        physiologique, génétique, psychique, économique,
                        culturelle ou sociale.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « Société »
                      </h4>
                      <p className="text-gray-700">
                        désignant une personne morale.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « Identifiant »
                      </h4>
                      <p className="text-gray-700">
                        désignant un identifiant unique définit par
                        l’utilisateur lors de la création de son compte
                        professionnel. Il permet à un utilisateur de
                        s'identifier et d'accéder à DCA ERP.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « DCA ERP »
                      </h4>
                      <p className="text-gray-700">
                        désignant la solution de plateforme d’échange créée et
                        gérée par DCA MONACO SAM.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « Données téléchargées »
                      </h4>
                      <p className="text-gray-700">
                        l’ensemble des données, documents, fichiers,
                        commentaires, informations ou matériels saisis sur DCA
                        ERP ou mis à disposition d’une autre manière par DCA
                        Monaco SAM.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600">
                        « Utilisateur »
                      </h4>
                      <p className="text-gray-700">
                        toute personne physique faisant usage de la plateforme
                        DCA ERP.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Article 4 */}
              <section
                id="article-4"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 4. Siège social
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Le siège social de DCA MONACO SAM est situé :
                  </p>
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <p className="text-gray-700 font-medium">
                      2 Rue de la Lüjerneta 98000 - MONACO
                    </p>
                    <p className="text-gray-700">Tél. +377 92 05 64 20</p>
                  </div>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    Le Site est hébergé par DCA MONACO SAM.
                  </p>
                </div>
              </section>

              {/* Article 5 */}
              <section
                id="article-5"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 5. Objet du site
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    DCA MONACO SAM a pour objet de proposer une plateforme
                    sécurisée d'échange de documents, dénommée « DCA ERP ».
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Depuis le Site, l'Utilisateur peut notamment :
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700 bg-white p-4 rounded-lg shadow-sm">
                    <li>
                      Se connecter en utilisant son Identifiant et son mot de
                      passe
                    </li>
                    <li>
                      Accéder aux différentes espaces qui lui sont attribuées
                      (Facturation ou Social) ;
                    </li>
                    <li>
                      Mettre en ligne des documents ou fichiers sur la
                      plateforme ainsi que télécharger ces mêmes documents
                      depuis DCA ERP
                    </li>
                    <li>
                      Consulter, déposer des documents ou fichiers sur la
                      plateforme ainsi que télécharger ces mêmes documents,
                      renseigner toutes types d’informations relatives aux
                      mission Social depuis DCA ERP ;
                    </li>
                    <li>
                      Accéder à DCA ERP depuis les supports numériques suivant :
                      PC, tablette et mobile.
                    </li>
                  </ul>
                </div>
              </section>

              {/* Article 6 */}
              <section
                id="article-6"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 6. Accès au site
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L'Utilisateur aura besoin d'un Identifiant et d'un mot de
                    passe pour accéder à DCA ERP ainsi que d'un code reçu par
                    mail (expirant tous les 14 jours à la demande de
                    l'utilisateur).
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L'Utilisateur et sa Société sont seuls responsables de tout
                    activité par le biais de leur Compte professionnel, à moins
                    que l'Utilisateur ou la Société demande sa désactivation.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    À tout moment, l’Utilisateur ou sa Société peuvent
                    désactiver le compte d’Utilisateur pour une raison
                    quelconque ou sans raison. Pour ce faire, l’Utilisateur ou
                    sa Société doivent envoyer une notification par email au
                    service IT. L’Utilisateur s’engage à avertir immédiatement
                    le service IT de toute utilisation non autorisée de ces
                    informations à l’adresse email suivante : info@dca.mc . DCA
                    MONACO SAM ne saurait être tenue pour responsable des
                    dommages éventuellement causés par l’utilisation de
                    l’Identifiant et du mot de passe par un tiers non autorisé.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Lors de sa première utilisation, l’Utilisateur est invité à
                    accéder à son Compte professionnel existant via l’email
                    d’information venant du Site. Pour créer un Compte
                    professionnel, il est nécessaire de renseigner : adresse
                    email, nom(s), prénom(s). Il doit appliquer à ces
                    informations toutes les précautions et mesures de sécurité
                    adéquates pour notamment en préserver l’intégrité et la
                    confidentialité
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L’Utilisateur s’engage à saisir lesdites données sous son
                    entière responsabilité, contrôle et direction et s’engage à
                    communiquer des informations complètes, exactes et
                    actualisées, et à ne pas usurper l’identité d’un tiers.
                    L’Utilisateur doit conserver de manière sécurisée son
                    Identifiant et son mot de passe qui lui seront utiles pour
                    tout accès à son Compte professionnel.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    La connexion au Compte professionnel s’opère en remplissant
                    l’Identifiant et le mot de passe personnels de l’Utilisateur
                    suivi par le code reçu par mail. En cas de succès,
                    l’Utilisateur accède à son Compte professionnel et aux
                    différentes interfaces qui lui sont affectées
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Si l’Utilisateur oublie son mot de passe, ce dernier doit
                    cliquer sur le lien « Mot de passe oublié ? » dans
                    l’interface de connexion. La procédure de récupération lui
                    est alors décrite.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Il est rappelé qu’un mot de passe est strictement personnel
                    et confidentiel et ne doit jamais être communiqué. Le mot de
                    passe personnel ne doit pas utiliser tout ou partie de
                    l’Identifiant, du prénom ou du nom de famille de
                    l’Utilisateur. L’Utilisateur s’engage à modifier sans délai
                    son mot de passe dès lors qu’il suspecte une utilisation
                    frauduleuse de son Compte professionnel et à ne jamais
                    stocker en clair son mot de passe.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L’Utilisateur devra fournir une adresse e-mail valide pour
                    la création du Compte professionnel. Cette adresse est
                    nécessaire et utilisée pour la confirmation des opérations
                    réalisées par l’Utilisateur.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Dans le cas où un Utilisateur souhaiterait faire part au
                    service IT d’une erreur ou d’une correction, il est prié de
                    le faire à l’adresse email suivante : v.otten@dca.mc .
                  </p>
                </div>
              </section>

              {/* Articles 7-21 - Structure similaire mais plus concise */}
              <section
                id="article-7"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 7. Conservation des données de connexion
                </h2>
                <div className="max-w-none space-y-3">
                  <div className="space-y-4">
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600 mb-2">
                        Compte professionnel
                      </h4>
                      <p className="text-gray-700">
                        Un Compte professionnel qui n’est pas utilisé pendant
                        plus de trois (3) ans entre dans un processus
                        automatique de désinscription. L’Utilisateur peut
                        également se désinscrire à tout moment en envoyant un
                        courriel à l’adresse email suivante : v.otten@dca.mc .
                      </p>
                      <p className="text-gray-700">
                        La désinscription entraine l’effacement définitif de
                        toutes les données de connexion de l’Utilisateur dans un
                        délai de dix (10) jours ouvrables
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600 mb-2">
                        Données de connexion
                      </h4>
                      <p className="text-gray-700">
                        Certaines données de connexion pourraient être
                        conservées à des fins de protection contre les
                        intrusions et d’éventuelles poursuites judiciaires le
                        cas échéant. Ces données sont conservées pendant douze
                        (12) mois selon les besoins de DCA Monaco SAM.
                      </p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <h4 className="font-semibold text-blue-600 mb-2">
                        Contenu mis en ligne
                      </h4>
                      <p className="text-gray-700">
                        Les documents et autres fichiers apportés sur la
                        plateforme sont conservés aux fins de permettre un accès
                        rétroactif aux données dans le cadre d’une inspection
                        sur les travaux effectués.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section
                id="article-8"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 8. Protection des données à caractère personnel
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Conformément aux dispositions de la loi n° 1.165 du 23
                    décembre 1993 relative à la protection des informations
                    nominatives, modifiée, DCA MONACO SAM en sa qualité de
                    responsable du traitement, s’engage à préserver la
                    confidentialité des Données à caractère personnel fournies
                    par les Utilisateurs dans le cadre de la création de leur
                    Compte professionnel.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Ces informations sont exploitées dans le cadre de
                    l’identification des Utilisateurs et pour des fins de
                    cybersécurité.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Le traitement des Données à caractère personnel s’inscrit
                    dans les Missions de DCA MONACO SAM. Il est justifié par le
                    consentement de l’Utilisateur et/ou par l'exécution d'un
                    contrat avec l’Utilisateur.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Les Données à caractère personnel ainsi collectées pourront
                    être conservées pendant la durée de l’existence du compte de
                    l'Utilisateur et dans la limite de douze (12) mois.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    En vertu de l’article 14 de la loi n°1.165 du 23 décembre
                    1993 modifiée, relative à la protection des informations
                    nominatives, l’Utilisateur dispose d’un droit d’accès, de
                    rectification et d’opposition concernant ses Données à
                    caractère personnel.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L’Utilisateur exerce ce droit auprès de la DCA MONACO SAM à
                    l’adresse suivante : L'Herakleia, 2 Boulevard du Jardin
                    Exotique 98000 - MONACO
                  </p>
                </div>
              </section>

              {/* Continuer avec les autres articles de manière similaire... */}
              <section
                id="article-9"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 9. Confidentialité et divulgation des informations
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    DCA MONACO SAM se réserve le droit de divulguer les
                    informations des Utilisateurs si elle y est contrainte afin
                    de se conformer à la loi, aux exigences règlementaires, aux
                    normes professionnelles ou pour prévenir tout préjudice à
                    l'Utilisateur concerné.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Dans ces hypothèses, l’Utilisateur sera informé sans délai
                    de la nécessité de divulgation de ses Données à caractère
                    personnel.
                  </p>
                </div>
              </section>

              <section
                id="article-10"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 10. Téléchargement des données sur DCA ERP
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Obligations relatives aux données téléchargées sur DCA ERP
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    DCA ERP permet aux Utilisateurs de télécharger les données
                    importées dans leur espace sur la plateforme.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    L’Utilisateur et la Société sont seuls responsables des
                    Données téléchargées, et sans limitation de ce qui précède,
                    ils s’assurent de ce qui suit :
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Autorisation appropriée de la Société à fournir les Données
                    téléchargées, Absence de contenu faux, offensant, indécent,
                    diffamatoire, calomnieux, harcelant, menaçant ou nuisible au
                    sein des Données téléchargées, Absence de violation de toute
                    loi, règlementation, norme professionnelle, vie privée d’un
                    tiers, droit d’auteur, marque commerciale ou droit de
                    propriété intellectuelle d’un tiers par la fourniture des
                    Données téléchargées.
                  </p>
                </div>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Accès aux Données téléchargées sur DCA ERP
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    L’Utilisateur et la Société conviennent de ce qui suit
                    s’agissant de l’accès et l’utilisation des Données
                    téléchargées :
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Les Données téléchargées sont disponibles pour DCA MONACO
                    SAM ainsi que ses salariés, Les Données téléchargées sont
                    disponibles pour le personnel du réseau, ainsi que pour les
                    sous-traitants de DCA MONACO SAM (qui peuvent inclurent de
                    manière non exhaustive des tiers fournissant des services
                    tels que l’administration, le soutien, la gestion ou
                    l’hébergement de DCA ERP) qui peuvent y accéder pour des
                    périodes limitées dans des circonstances telles que
                    l’administration du site, le dépannage, la maintenance du
                    système, les urgences, tout soutien technique, ou si la loi
                    ou toute procédure l’exige.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Il est par ailleurs précisé que dans cette hypothèse, les
                    personnes ayant accès aux Données téléchargées seront
                    soumise à une obligation de confidentialité. DCA MONACO SAM
                    se réserve d’examiner et supprimer le cas échéant de DCA
                    ERP, une partie ou l’ensemble des Données téléchargées s’il
                    est estimé que ces dernières ont été fournies en violation
                    des Conditions générales d’utilisation, ou si elles sont
                    périmées ou non pertinentes pour les Utilisateurs. Toutefois
                    et sauf indication contraire, DCA MONACO SAM n’est pas tenue
                    de vérifier l’exhaustivité, l’authenticité ou l’actualité
                    des Données téléchargées, ni d’en examiner la nature ou le
                    contenu.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Autrement dit, les Données téléchargées ne sont utilisées
                    par DCA MONACO SAM que conformément aux conditions de la
                    lettre de mission applicable.
                  </p>
                </div>
              </section>

              {/* Articles 11-21 avec structure similaire */}
              <section
                id="article-11"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 11. Accessibilité et disponibilité
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    DCA ERP ne garantit aucun stockage des Données téléchargées.
                    Il est conseillé à l'Utilisateur et à la Société de
                    conserver des copies de toutes les Données téléchargées.
                  </p>
                </div>
              </section>

              <section
                id="article-12"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 12. Engagement concernant l'utilisation du site et de
                  son contenu
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    L'Utilisateur s'engage à ne pas commettre, sur DCA ERP,
                    d’acte illicite ou portant atteinte aux droits de la
                    personne, et plus généralement aux intérêts de tiers.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Est prohibé par les Conditions générales d’utilisation, tout
                    acte pouvant contribuer à ternir le nom et/ou l’image de DCA
                    MONACO SAM, ou pouvant endommager, surcharger, mettre hors
                    d'état, discréditer ou mettre en échec DCA ERP.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Est notamment prohibé : la transmission, par courrier
                    électronique ou par tout autre moyen au travers de la
                    plateforme DCA ERP, des contenus servant à des fins de
                    persécution, harcèlement, diffamation, discrimination,
                    insultes, ou toute autre diffusion d'information ou
                    d’opinion à caractère personnel sur un ou plusieurs
                    individus ou portant atteinte aux droits de la personne ou
                    aux Utilisateurs.
                  </p>
                </div>
              </section>

              <section
                id="article-13"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 13. Sécurité du site
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    DCA ERP requiert une configuration internet suffisamment
                    rapide, ainsi que des équipements et des moyens matériels
                    permettant d’accéder et de naviguer sur DCA ERP, à la charge
                    et aux frais de l’Utilisateur. Le navigateur doit être
                    configuré pour autoriser les « cookies » de session. Il doit
                    également être configuré afin d'autoriser l'ouverture de
                    fenêtres pour le site DCA ERP. Afin de garantir un bon
                    fonctionnement du Site, il est conseillé d’utiliser les
                    versions récentes des navigateurs ci-dessous :
                  </p>
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Google Chrome</li>
                      <li>Microsoft Edge</li>
                      <li>Apple Safari</li>
                      <li>Firefox</li>
                      <li>Opéra</li>
                    </ul>
                  </div>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L’Utilisateur a conscience des risques inhérents à
                    l’utilisation du réseau internet et en accepte les limites
                    et les risques. Le service IT fera ses meilleurs efforts
                    pour sécuriser le Site au regard des risques encourus et de
                    la nature des données traitées et en compliance avec les
                    meilleurs standards de sécurité informatique. Il est
                    interdit à l’Utilisateur d’accéder ou de se maintenir,
                    frauduleusement, dans tout ou partie du Site, de supprimer
                    ou modifier les données contenues sur le Site, d’y
                    introduire frauduleusement des données, d’altérer le Site ou
                    de perturber son bon fonctionnement
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L’Utilisateur s’engage à ne pas tenter de modifier ou
                    manipuler les pages du Site de manière à dissimuler,
                    détourner ou modifier cette dernière.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Il est strictement interdit : (i) de reproduire, modifier,
                    adapter, altérer le Site et/ou son contenu; (ii) d’accéder
                    ou rechercher à accéder au code source du Site, en ayant
                    recours à des techniques de décompilation, d’ingénierie
                    inverse ou quelque autre moyen que ce soit; (iii) de rendre
                    accessible ou de transmettre des parties du Site ou du
                    contenu dont l’accès est restreint à disposition de tiers
                    (iv) d’utiliser ou de tenter d’utiliser des Comptes autres
                    que ceux qui lui sont attribués ou masquer son identité ;
                    (v) d’utiliser le Site dans un but illicite, à ce titre,
                    l’Utilisateur s’engage à n’inclure aucune information
                    fausse, incomplète ou inexacte, à n’inclure aucun virus,
                    cheval de Troie, ver, bombe à retardement ou tout autre
                    programme conçu pour endommager, produire un effet néfaste,
                    intercepter ou contrer tout système, donnée ou information
                    personnelle.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Il doit le cas échéant disposer d’une connexion ou d’un
                    réseau sécurisé, d’un antivirus, d’un système d’exploitation
                    à jour pour prévenir tant que faire se peut tous dommages
                    relatifs à une utilisation du Site non sécurisée.
                    L’Utilisateur s’engage à prendre toutes les mesures
                    appropriées de façon à protéger ses données et matériels, il
                    est responsable de la sécurité de ses données et de son
                    réseau qu’il utilise à ses propres risques.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Dans le cas où l’Utilisateur aurait connaissance d’un
                    évènement pouvant porter atteinte à la sécurité du Site,
                    telles qu’une erreur, faute, dysfonctionnement, intrusion,
                    perte de données, vulnérabilité ou irrégularités, il est
                    invité à contacter immédiatement le service IT par courriel
                    à l’adresse email suivante : v.otten@dca.mc .
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Sauf autorisation contraire, l’Utilisateur et son entreprise
                    doivent :
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Sauf si la loi l'exige, limiter l'accès au contenu de DCA
                    ERP aux seules personnes qui ont un besoin direct et
                    immédiat de cet accès et qui sont tenues d'en préserver la
                    confidentialité. Ne pas copier, télécharger, reproduire,
                    modifier ou distribuer la Technologie de DCA ERP en tout ou
                    en partie. N’accéder qu'aux sections de DCA ERP auxquelles
                    il lui est donné accès, et ne pas pirater ou tenter
                    d'accéder d'une autre manière à d'autres sections de DCA
                    ERP. L’Utilisateur doit immédiatement cesser d'utiliser son
                    Compte professionnel de DCA ERP si son emploi ou toute autre
                    relation de travail avec sa Société est résilié pour quelque
                    raison que ce soit
                  </p>
                </div>
              </section>

              <section
                id="article-14"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 14. Propriété intellectuelle
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Ce site est la propriété exclusive de DCA MONACO SAM. Les
                    Conditions générales d’utilisation n'emportent aucune
                    cession d'aucune sorte de droits de propriété intellectuelle
                    au bénéfice de l’Utilisateur.
                  </p>
                </div>
              </section>

              <section
                id="article-15"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 15. Droits d'auteur
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Tous les contenus (qu'il s'agisse de manière non exhaustive
                    de textes, commentaires, titres, photographies, images,
                    données, dessins, …) reproduits sur le site DCA ERP, ainsi
                    que la conception, la forme et les logiciels sont la
                    propriété exclusive de DCA MONACO SAM (sauf mentions
                    spéciales) et sont protégés par les dispositions
                    législatives en vigueur, relatives à la protection du droit
                    d’auteur à Monaco. Seule la copie électronique à usage privé
                    de tout ou partie du Site ou des éléments le composant est
                    autorisé par DCA MONACO SAM, sous réserve de ne pas en
                    modifier l'original.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    DCA MONACO SAM accorde aux Utilisateurs du Site un droit
                    d'usage professionnel, ponctuel et non exclusif, de
                    celui-ci.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Toute forme de reproduction, de copie, d’utilisation, de
                    modification, de diffusion, d’adaptation ou d'exploitation,
                    dans un but commercial ou non, de tout élément ou du contenu
                    du Site, sur quelque support et par quelque procédé que
                    soit, dans un but autre que celui mentionné ci-dessus, est
                    strictement prohibée et constitue une infraction pénale
                    sanctionnée par devant les juridictions compétentes
                    monégasques.
                  </p>
                </div>
              </section>

              <section
                id="article-16"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 16. Marques
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Les marques et/ou logos dont est titulaire DCA MONACO SAM,
                    apparaissant sur ce Site sont des marques protégées par des
                    dispositifs du droit de la propriété intellectuelle. Toute
                    reproduction de ces derniers, en tout ou partie, sans
                    l'autorisation préalable écrite de DCA MONACO SAM constitue
                    une infraction pénale sanctionnée par devant les
                    Juridictions compétentes monégasques.
                  </p>
                </div>
              </section>

              <section
                id="article-17"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 17. Responsabilité et force majeure
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Il n'existe aucune garantie que DCA ERP sera disponible pour
                    l’Utilisateur ou sa Société. DCA MONACO SAM pourra modifier,
                    suspendre ou résilier DCA ERP à tout moment, à sa seule
                    discrétion. DCA MONACO SAM ne garantit pas la continuité,
                    l'accès et la disponibilité du fonctionnement du Site et des
                    services afférents. DCA MONACO SAM décline toute
                    responsabilité relative aux virus qui pourraient être
                    importés lors du téléchargement de l'un des éléments du Site
                    ou des sites auxquels DCA ERP renvoie par le biais de liens
                    hypertextes. La responsabilité de DCA MONACO SAM ne peut
                    être engagée en cas de force majeure ou du fait imprévisible
                    et insurmontable causé par un tiers.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">HYPERTEXTES</p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Les liens vers le Site et en direction d'autres sites
                    doivent faire l'objet d'une autorisation préalable de la
                    part de DCA MONACO SAM. Cependant, DCA MONACO SAM ne
                    contrôle pas ces sites et ne pourrait être tenue
                    responsable, ni supporter aucune responsabilité quant aux
                    contenus, publicités, produits, services ou tout autre
                    matériel disponible à partir de ces sites tiers.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    DCA MONACO SAM ne pourrait être tenue responsable de tous
                    dommages ou pertes avérés ou allégués consécutifs ou en
                    relation avec l'utilisation ou avec le fait d'avoir fait
                    confiance au contenu des sites tiers ou aux biens et
                    services disponibles sur ces sites tiers.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    L'Utilisateur est responsable et supporte tous les risques
                    afférents à l'utilisation qu'il fait du contenu du Site,
                    notamment lorsqu'il se fie à l'opportunité, l'utilité ou le
                    caractère complet de ce contenu. Si un lien amenait
                    l'Utilisateur à pointer vers des contenus illicites, en
                    infraction avec la législation en vigueur, l'Utilisateur
                    devrait alors interrompre sa consultation du site concerné,
                    sauf à encourir les sanctions prévues par ladite législation
                    et à répondre des actions en justice initiées à son
                    encontre.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    En pareille hypothèse, DCA MONACO SAM invite l'Utilisateur à
                    l'en informer immédiatement par courriel à l’adresse
                    suivante : v.otten@dca.mc . En tout état de cause,
                    l’Utilisateur s’interdit d’engager la responsabilité de DCA
                    MONACO SAM concernant le contenu et les ressources relatives
                    à ces liens hypertextes sortants.
                  </p>
                </div>
              </section>

              <section
                id="article-18"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 18. Cookies
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    La plateforme DCA ERP utilise la technologie de suivi des «
                    cookies ». Un « cookie » ne permet pas d’identifier
                    l’Utilisateur. En revanche, il enregistre des informations
                    relatives à la navigation de son ordinateur sur le Site.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Parmi les « cookies » présents, sera récupéré le nom du PC
                    établissant une identification sur DCA ERP. Cette donnée
                    sera utilisée à des fins de sécurité
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    La durée de conservation de ces informations dans
                    l’ordinateur de l’Utilisateur est de trois (3) ans.
                  </p>
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    En tout état de cause, tout Utilisateur peut s’opposer à
                    l'enregistrement de « cookies » en configurant cette option
                    sur son navigateur.
                  </p>
                </div>
              </section>

              <section
                id="article-19"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 19. Évolution des Conditions générales d'utilisation
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Les termes des Conditions générales d’utilisation peuvent
                    être amendés à tout moment, sans préavis, en fonction des
                    modifications opérées par le service IT, de l’évolution de
                    la législation ou de tout autre motif qui sera jugé
                    nécessaire. Il appartient à l’Utilisateur de s’informer
                    desdites conditions modifiées qui apparaîtront dans ce but
                    sur le Site dès leur modification pour acceptation par
                    l’Utilisateur.
                  </p>
                </div>
              </section>

              <section
                id="article-20"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 20. Durée
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    La durée des Conditions générales d’utilisation est
                    indéterminée et ces dernières produisent leurs effets à
                    l’égard de l’Utilisateur à compter de la première
                    utilisation de DCA ERP.
                  </p>
                </div>
              </section>

              <section
                id="article-21"
                className="mb-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5"
              >
                <h2 className="mb-3 text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                  Article 21. Droit applicable et juridiction compétente
                </h2>
                <div className="max-w-none space-y-3">
                  <p className="font-Nunito text-sm leading-relaxed text-slate-600">
                    Les Conditions générales d’utilisation sont régies par le
                    seul droit monégasque. Tout différend relatif à l’existence,
                    la validité, l’interprétation, l’exécution ou se référant
                    plus largement pour quelque raison qu’il soit aux Conditions
                    générales d’utilisation et qui ne saurait se résoudre de
                    façon amiable, sera réglé de manière exclusive par devant
                    les tribunaux compétents de la Principauté de Monaco.
                  </p>
                </div>
              </section>
          </div>
        </div>
      </PagePanel>
    </PageShell>
  );
};

export default CGU;
